import React, { useEffect, useState } from 'react';
import { useNavigate } from 'react-router-dom'; // Importa el hook useNavigate
import './splashscreen.css'; // Importa el archivo de estilos
const logo = process.env.PUBLIC_URL + '/tigo_logo_white.svg';

const SplashScreen = () => {
    const navigate = useNavigate(); // Obtén la función navigate para la navegación

    const handleNavigation = () => {
        navigate('/signin'); // Cambia a la ruta de inicio de sesión
    };

    const [showFooter, setShowFooter] = useState(false); // Estado para controlar la visibilidad del panel

    useEffect(() => {
        const timer = setTimeout(() => {
            setShowFooter(true);
        }, 500); // Retraso de 500ms antes de mostrar el panel

        return () => clearTimeout(timer);
    }, []);

    return (
        <div className="splash-page">
            <div className="splash-logo">
                <img src={logo} alt="Tigo" />
            </div>
            <div className={`splash-panel ${showFooter ? 'show' : ''}`}>
                <h2 className="splash-title">¡Asignación de nuevos leads!</h2>
                <p className="splash-text">Inicia sesión con tu cuenta</p>
                <button className="splash-btn" onClick={handleNavigation}>
                    Comenzar
                </button>
            </div>
        </div>
    );
};

export default SplashScreen;
